import React, { Component } from 'react'
import { connect } from 'react-redux'
import { initializeConfiguration } from '../actions/app'
import { DispatchThunk } from '../actions/types'
import LoadingOverlay from '../components/LoadingOverlay'
import UploadOptions from './UploadOptions'
import { WtaiUploadWidgetProps } from '../types'
import {
  selectRelativeBounding,
  selectWrapperClass,
  selectDisplayLegal,
  selectTermsAndConditionsUrl,
} from '../selectors/site'
import { StoreState } from '../reducer/types'
import { TERMS_CONDITIONS_COPY } from '../constants'
import { TermsConditionsContainer } from '../styles'

interface StateProps {
  uploading: boolean
  boundingStyle: string
  wrapperClass: string
  displayLegal: boolean
  termsAndConditionsUrl: string
}

interface DispatchProps {
  initializeConfiguration: () => void
}

type ComponentProps = Pick<
  WtaiUploadWidgetProps,
  | 'headingText'
  | 'subheadingText'
  | 'site'
  | 'initFreshToken'
  | 'pasteOnly'
  | 'alignText'
  | 'includeTerms'
  | 'termsTextColor'
>

export type AppProps = StateProps & DispatchProps & ComponentProps

export class App extends Component<AppProps> {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.props.initializeConfiguration()
    }
  }

  render() {
    const {
      uploading,
      headingText,
      subheadingText,
      pasteOnly,
      alignText,
      site,
      boundingStyle,
      wrapperClass,
      displayLegal,
      termsAndConditionsUrl,
      includeTerms,
      termsTextColor,
    } = this.props
    return (
      <div className={boundingStyle}>
        <div className={wrapperClass}>
          <LoadingOverlay displayLegal={displayLegal} uploading={uploading}>
            <UploadOptions
              headingText={headingText}
              subheadingText={subheadingText}
              pasteOnly={pasteOnly}
              alignText={alignText}
              site={site}
            />
          </LoadingOverlay>
        </div>
        {includeTerms &&
          !uploading && (
            <TermsConditionsContainer textColor={termsTextColor}>
              <a href={termsAndConditionsUrl}>*{TERMS_CONDITIONS_COPY}</a>
            </TermsConditionsContainer>
          )}
      </div>
    )
  }
}

const mapStateToProps = (state: StoreState): StateProps => ({
  uploading: state.upload.uploading,
  boundingStyle: selectRelativeBounding(state),
  wrapperClass: selectWrapperClass(state),
  displayLegal: selectDisplayLegal(state),
  termsAndConditionsUrl: selectTermsAndConditionsUrl(state),
})

const mapDispatchToProps = (dispatch: DispatchThunk) => ({
  initializeConfiguration: () => dispatch(initializeConfiguration),
})

export default connect<StateProps, DispatchProps>(
  // @ts-ignore
  mapStateToProps,
  mapDispatchToProps
)(App)
